import { DatePicker, Modal, message, Image, Row, Col, Button, Space, Radio, Card, Input, Select, Checkbox, Typography, Form } from 'antd';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Navigate, Outlet, useNavigate, useLocation } from 'react-router-dom'
import { InboxOutlined, HeartOutlined } from '@ant-design/icons';
import { useForm } from 'rc-field-form';
import axios from 'axios';
import './css/cramSchool.css';
const { Title, Paragraph, Text, Link } = Typography;

const InputOutline = styled.div`
    .ant-select-focused .ant-select-selector,
    .ant-select-selector:focus,
    .ant-select-selector:active,
    .ant-select-open .ant-select-selector {
    border-color: #d9d9d9 !important;
    box-shadow: none !important;
    }
    .ant-input{
        border-top-style: hidden;
        border-right-style: hidden;
        border-left-style: hidden;
        border-bottom-style: groove;
        border-radius:0px;
        background-color:#f5f5f5;
        border-width:2px
    }
    .ant-select-selector{
        border-top-style: hidden;
        border-right-style: hidden;
        border-left-style: hidden;
        border-bottom-style: groove;
        border-radius:0px;
        background-color:#f5f5f5;
    }
    .ant-input-status-error{
        border-top-style: hidden;
        border-right-style: hidden;
        border-left-style: hidden;
        border-bottom-style: groove;
        border-radius:0px;
        background-color:#f5f5f5;
        border-width:5px;
    }
`;
const Enroll = () => {
    const [messageApi, contextHolder] = message.useMessage();
    const [modal_open, set_modal_open] = useState(false);
    const [grade_option, set_grade_option] = useState([]);
    const [agree, set_agree] = useState(false);
    const [form_data, set_form_data] = useState([]);
    const [data, setData] = useState([{
        key: 1,
        name: 'client',
        label: '學生姓名',
        placeholder: '請輸入名字（必填）',
        type: 'input',
        value: '',
        required: 'true',
    }, {
        key: 2,
        name: 'client',
        label: '家長姓名',
        placeholder: '請輸入名字（必填）',
        type: 'input',
        value: '',
        required: 'true',
    }, {
        key: 3,
        name: 'gender',
        label: '性別',
        type: 'radio',
        value: '',
        required: 'true',
    }, {
        key: 4,
        name: 'birth',
        label: '生日',
        placeholder: '請輸入生日（必填）',
        type: 'datepicker',
        value: '',
        required: 'true',
    }, {
        key: 5,
        name: 'phone',
        label: '聯絡電話',
        placeholder: '請輸入聯絡電話（必填）',
        type: 'input',
        value: '',
        required: 'true',
    }, {
        key: 6,
        name: 'school',
        label: '就讀學校',
        placeholder: '請輸入就讀學校（必填）',
        type: 'input',
        value: '',
        required: 'true',
    }, {
        key: 7,
        name: 'e_mail',
        label: '電子郵件',
        placeholder: '請輸入電子郵件（選填）',
        type: 'input',
        value: '',
        required: 'false',
    }, {
        key: 8,
        name: 'question',
        label: '地址',
        placeholder: '請輸入地址（選填）',
        type: 'input',
        value: '',
        required: 'false',
    }, {
        key: 9,
        name: 'grade_id',
        placeholder: '請選擇想報名的課程',
        type: 'select',
        value: '',
    },])
    useEffect(() => {
        get_grade();
    }, [])
    const get_grade = () => {
        axios
            .get('/cramSchool/api/grade')
            .then((response) => {
                let data_tmp = [];
                response.data.map((value, index) => {
                    let data_json_tmp = {};
                    data_json_tmp['value'] = value['id']
                    data_json_tmp['label'] = `${value['name']}`;
                    data_tmp.push(data_json_tmp);
                })
                set_grade_option(data_tmp)
            })
    }
    const onSubmit = () => {
        if (form_data['client'] != '' && form_data['phone'] != '' && form_data['grade_id'] && form_data['school']) {
            axios
                .post('/cramSchool/api/contact', [form_data])
                .then((response) => {
                    if (response.data.status == 'failure') {
                        messageApi.open({
                            type: 'error',
                            content: '送出失敗',
                        });
                    } else {
                        messageApi.open({
                            type: 'success',
                            content: '已成功送出，會盡快聯繫',
                        });
                        setTimeout(() => {
                            window.location.reload();
                        }, 1000)
                    }
                })
        } else {
            messageApi.open({
                type: 'error',
                content: '請確認資料是否填寫完整',
            });
        }
    };
    const handleChange = (name, value) => {
        set_form_data(pre => {
            return ({
                ...pre,
                [`${name}`]: value
            })
        })
    }
    return (
        <>
            {contextHolder}
            <InputOutline>
                <Modal title="舊生報名" open={modal_open}
                    // onOk={handleNewColumn}
                    onCancel={e => set_modal_open(false)}
                    width={600}
                >
                    <Row gutter={[16, 24]} align={'middle'} style={{ paddingBottom: '10px', paddingTop: '10px' }}>
                        <Col>學號：</Col>
                        <Col>
                            <Input placeholder={'請輸入學號'} />
                        </Col>
                        <Col ><span style={{ whiteSpace: 'nowrap' }}>想報名的課程：</span></Col>
                        <Col >
                            <Select
                                style={{
                                    width: "100%",
                                }}
                                placeholder={'請選擇想報名的課程'}
                                // onChange={(value) => set_form_data(pre => {
                                //     return ({
                                //         ...pre,
                                //         'grade_id': value
                                //     })
                                // })}
                                options={grade_option}
                            />
                        </Col>
                    </Row>
                </Modal >
                <Row justify='center' style={{ paddingBottom: '10px' }}>
                    <div style={{ fontSize: '65px' }}>我要報名</div>
                </Row>
                <Row gutter={[0, 24]} justify='center'>
                    <Col sm={{ span: 24 }} md={{ span: 18 }} style={{ border: 'solid #f5be9d 4px ', padding: '15px', minHeight: '400px', maxHeight: '400px', overflowY: 'auto' }}>
                        <div style={{ padding: '10px', maxHeight: '450px' }}>
                            <h1>隱私權條款範本文件</h1>
                            <span>非常歡迎您光臨「私立MERCY文理短期補習班」（以下簡稱本網站），為了讓您能夠安心的使用本網站的各項服務與資訊，特此向您說明本網站的隱私權保護政策，以保障您的權益，請您詳閱下列內容：</span>
                            <h4>一、隱私權保護政策的適用範圍</h4>
                            隱私權保護政策內容，包括本網站如何處理在您使用網站服務時收集到的個人識別資料。隱私權保護政策不適用於本網站以外的相關連結網站，也不適用於非本網站所委託或參與管理的人員。
                            <h4>二、個人資料的蒐集、處理及利用方式</h4>
                            <p>•	當您造訪本網站或使用本網站所提供之功能服務時，我們將視該服務功能性質，請您提供必要的個人資料，並在該特定目的範圍內處理及利用您的個人資料；非經您書面同意，本網站不會將個人資料用於其他用途。</p>
                            <p>•	本網站在您使用服務信箱、問卷調查等互動性功能時，會保留您所提供的姓名、電子郵件地址、聯絡方式及使用時間等。</p>
                            <p>•	於一般瀏覽時，伺服器會自行記錄相關行徑，包括您使用連線設備的IP位址、使用時間、使用的瀏覽器、瀏覽及點選資料記錄等，做為我們增進網站服務的參考依據，此記錄為內部應用，決不對外公佈。</p>
                            <p>•	為提供精確的服務，我們會將收集的問卷調查內容進行統計與分析，分析結果之統計數據或說明文字呈現，除供內部研究外，我們會視需要公佈統計數據及說明文字，但不涉及特定個人之資料。</p>
                            <h4>三、資料之保護</h4>
                            <p>•	本網站主機均設有防火牆、防毒系統等相關的各項資訊安全設備及必要的安全防護措施，加以保護網站及您的個人資料採用嚴格的保護措施，只由經過授權的人員才能接觸您的個人資料，相關處理人員皆簽有保密合約，如有違反保密義務者，將會受到相關的法律處分。</p>
                            <p>•	如因業務需要有必要委託其他單位提供服務時，本網站亦會嚴格要求其遵守保密義務，並且採取必要檢查程序以確定其將確實遵守。</p>
                            <h4>四、網站對外的相關連結</h4>
                            <p>本網站的網頁提供其他網站的網路連結，您也可經由本網站所提供的連結，點選進入其他網站。但該連結網站不適用本網站的隱私權保護政策，您必須參考該連結網站中的隱私權保護政策。</p>
                            <h4>五、與第三人共用個人資料之政策</h4>
                            <p>本網站絕不會提供、交換、出租或出售任何您的個人資料給其他個人、團體、私人企業或公務機關，但有法律依據或合約義務者，不在此限。</p>
                            <p>前項但書之情形包括不限於：</p>
                            <p>•	經由您書面同意。</p>
                            <p>•	法律明文規定。</p>
                            <p>•	為免除您生命、身體、自由或財產上之危險。</p>
                            <p>•	與公務機關或學術研究機構合作，基於公共利益為統計或學術研究而有必要，且資料經過提供者處理或蒐集著依其揭露方式無從識別特定之當事人。</p>
                            <p>•	當您在網站的行為，違反服務條款或可能損害或妨礙網站與其他使用者權益或導致任何人遭受損害時，經網站管理單位研析揭露您的個人資料是為了辨識、聯絡或採取法律行動所必要者。</p>
                            <p>•	有利於您的權益。</p>
                            <p>•	本網站委託廠商協助蒐集、處理或利用您的個人資料時，將對委外廠商或個人善盡監督管理之責。</p>
                            <h4>六、Cookie之使用</h4>
                            為了提供您最佳的服務，本網站會在您的電腦中放置並取用我們的 Cookie，若您不願接受 Cookie 的寫入，您可在您使用的瀏覽器功能項中設定隱私權等級為高，即可拒絕 Cookie 的寫入，但可能會導致網站某些功能無法正常執行。
                            <h4>七、隱私權保護政策之修正</h4>
                            本網站隱私權保護政策將因應需求隨時進行修正，修正後的條款將刊登於網站上。
                        </div>
                    </Col>
                    <Col sm={{ span: 24 }} md={{ span: 18 }}>
                        <Checkbox checked={agree} onChange={e => set_agree(!agree)} style={{ color: '#006D9B', fontSize: '15px' }}>我同意這些條款和條件</Checkbox>
                    </Col>
                    <Col sm={{ span: 24 }} md={{ span: 20 }}  >
                        <Form autoComplete="off">
                            <Row gutter={[24, 16]} justify='center'>
                                <Col sm={{ span: 24 }} md={{ span: 20 }}>
                                    <Col span={24}>
                                        <Radio.Group onChange={(e) => e.target.value == '1' ? set_modal_open(true) : null}>
                                            <Space direction="vertical">
                                                <Row>
                                                    {/* <Col sm={{ span: 24 }} md={{ span: 12 }}> */}
                                                    <Radio value={1} style={{ color: '#006D9B', fontSize: '15px' }}>我是舊生</Radio>
                                                    {/* </Col> */}
                                                    {/* {additional_test == '1' && (
                                                        <Col sm={{ span: 24 }} md={{ span: 12 }} >
                                                            <Input
                                                                value={form_data['test_name'] || ''}
                                                                placeholder={'請輸入學號'}
                                                                onChange={(e) => additional_test == '1' ?
                                                                    set_form_data(pre => {
                                                                        return ({
                                                                            ...pre,
                                                                            'test_name': e.target.value
                                                                        })
                                                                    }) : null} />
                                                        </Col>)} */}
                                                </Row>
                                                {/* <Col sm={{ span: 12 }} md={{ span: 12 }}> */}
                                                <Radio value={0} style={{ color: '#006D9B', fontSize: '15px' }}>我是新生</Radio>
                                                {/* </Col> */}
                                            </Space>
                                        </Radio.Group>

                                    </Col>
                                </Col>
                                {grade_option && data.map((value, key) => {
                                    if (value.type == 'select') {
                                        return (
                                            <Col sm={{ span: 24 }} md={{ span: 10 }}  >
                                                <Row>
                                                    <Col md={{ span: 11 }} sm={{ span: 24 }}><span style={{ whiteSpace: 'nowrap' }}>想報名的課程：</span></Col>
                                                    <Col md={{ span: 13 }} sm={{ span: 24 }}>
                                                        <Select
                                                            style={{
                                                                width: "100%",
                                                            }}
                                                            placeholder={value.placeholder}
                                                            value={form_data['grade_id'] || value.placeholder}
                                                            onChange={(value) => set_form_data(pre => {
                                                                return ({
                                                                    ...pre,
                                                                    'grade_id': value
                                                                })
                                                            })}
                                                            options={grade_option}
                                                        />
                                                    </Col>
                                                </Row>
                                            </Col>
                                        )
                                    } else if (value.type == 'radio') {
                                        return (
                                            <>
                                                <Col sm={{ span: 24 }} md={{ span: 5 }}  >
                                                    <Row gutter={8}>
                                                        <Col>性別：</Col>
                                                        <Col>
                                                            <Radio value={0} style={{ color: '#006D9B', fontSize: '15px' }}>男</Radio>
                                                            <Radio value={1} style={{ color: '#006D9B', fontSize: '15px' }}>女</Radio>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </>
                                        )
                                    } else if (value.type == 'datepicker') {
                                        return (
                                            <Col sm={{ span: 24 }} md={{ span: 5 }}  >
                                                <Row gutter={8} align={'middle'}>
                                                    <Col>生日：</Col>
                                                    <DatePicker></DatePicker>
                                                </Row>
                                            </Col>
                                        )
                                    } else {
                                        return (
                                            <Col sm={{ span: 24 }} md={{ span: 10 }}  >
                                                <Form.Item
                                                    // {...formItemLayout}
                                                    name={value.name}
                                                    label={value.label}
                                                // rules={[
                                                //     {
                                                //         required: `${value.required}`,
                                                //         message: '',
                                                //     },
                                                // ]}
                                                >
                                                    <Input placeholder={value.placeholder}
                                                        onChange={(e) => handleChange(value.name, e.target.value)}
                                                        value={form_data[`${value.name}`] || value.placeholder}
                                                    />
                                                </Form.Item>

                                            </Col>
                                        )
                                    }
                                })}

                            </Row>
                            <Row justify="center" style={{ padding: '10px' }}>
                                <Col span={20}>
                                    <Button className='example' block style={{ background: agree == true ? '#566FB8' : 'gray' }} size='large' onClick={onSubmit} disabled={agree == true ? false : true}>
                                        <div style={{ color: '#ffffff', fontSize: '14px' }}>
                                            送出
                                        </div>
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    </Col>
                </Row >
            </InputOutline >
        </>
    )
}
export default Enroll;